import React, { useContext, useEffect, useState, useRef } from "react";
import OtherUploadExcel from "./OtherUploadExcel";
// import Modal from '../../../TrucksAvailable/PopupModal1/PopupModal';
import Modal from "../../../Shared/PopupModal/PopupModal";
import { toast } from "react-toastify";
import {
  DeleteMastersApi,
  MastersChangeLog,
  findChangedValues,
  getCompanyMaster,
  getCompanyMasterPagination,
  saveMastersApi,
} from "../../Utility";
import classes from "./Othermaster.module.css";
import Loader from "../../../Loader/Loader";
import { Urls } from "../../../../Urls";
import { Activity, currentRequestTimeStamp } from "../../../../Constants";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import _ from "lodash";
import axios from "../../../../Axios/Axios";
import Pagination from "react-js-pagination";
import MasterDropdown from "./MasterDropdown";
import DownloadMastersButton from "../Utility/DownloadMastersButton";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { isSuperUser } from "../FreightMaster/UploadExcel/Step1/utils";
import { EditableEmailsContext } from "../../../../Context/EditableEmailsContext";
import { sendMailToMasters } from "../Utility/utility";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import MultiSelectFilterUI from "../../../Shared/newfilterui/MultiSelectFilterUI";
import ShowHistory from "../../../Planning/components/ShowHistory";

const OtherMaster = ({ canedit = true, canAccess, canUpdate, checkActionPermission }) => {
  const [otherMasterList, setOtherMasterList] = useState([]);
  const [company_id, setcompany_id] = useState("");
  const { companyProfile } = useContext(UserApiContext);
  const [show, setshow] = useState(false);
  const { userDetails } = useContext(UserApiContext);
  const [deletion_list, setDeletion_list] = useState([]);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [skipactive, setSkipactive] = useState(0);
  const isSavedRef = useRef(false);
  const [totalcount, settotalcount] = useState(0);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const [selectedOrg, setSelectedOrg] = useState("company");
  const [orgList, setOrgList] = useState([]);
  const [isOrgLevel, setIsOrgLevel] = useState(false);

  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [filtersshown, setfiltershown] = useState(false);

  const DEFAULT_SORT_OPTIONS = [
    { value: 'material_code', label: 'Material Code' },
    { value: 'material_description', label: 'Material Description' },
    { value: 'material_type', label: 'Material Type' },
    { value: 'material_category', label: 'Material Category' },
    { value: 'weight', label: 'Weight' },
    { value: 'volume', label: 'Volume' },
  ];

  const [superAdmins, setSuperAdmins] = useState([])
  const [emailTemplate, setEmailTemplate] = useState({
    from: '',
    content: '',
    subject: '',
    cc: [],
    description: ''
  })

  const emailData = useContext(EditableEmailsContext);

  useEffect(() => {
    if (emailData && emailData?.notifyEmailForMastersUpdate) {
      setEmailTemplate({
        content: emailData?.notifyEmailForMastersUpdate?.content,
        subject: emailData?.notifyEmailForMastersUpdate?.subject,
        cc: emailData?.notifyEmailForMastersUpdate?.cc || "connect@logisticsnow.in",
        from: emailData?.notifyEmailForMastersUpdate?.from,
        description: emailData?.notifyEmailForMastersUpdate?.email_description
      })
    }
  }, [emailData])

  useEffect(() => {
    if (companySettingData && companySettingData?.contact_information && companySettingData?.contact_information?.length > 0) {
      const superAdminEmails = companySettingData?.contact_information?.filter((t) => t?.super_admin === true)?.map((m) => {
        return {
          name: m?.name,
          email: m?.email
        }
      })
      if (superAdminEmails && superAdminEmails?.length > 0) {
        setSuperAdmins(superAdminEmails)
      } else {
        setSuperAdmins([])
      }
    } else {
      setSuperAdmins([])
    }
  }, [companySettingData])


  const buildDefaultPayload = (skip = 0, limit = 500) => ({
    filter_opertaion: 'and',
    date_range: [],
    filters: [],
    sort: { key: 'material_code', order: 'asc' },
    pagination: { skip, limit },
  });


  const getMaterialData = (payload, orgId, showToast = false) => {
    setshow(true);
    const org = orgId || selectedOrg;
    const orgParam = org && org !== 'company' ? `&organization_id=${org}` : '';
    const url = `${Urls.companyMaster}?master_type=material&action=fetch_masters_data${orgParam}`;
    axios
      .post(url, payload)
      .then(res => {
        let count = 0;
        if (res.data && res.data.master_details) {
          setOtherMasterList(res.data.master_details);
          settotalcount(res.data.total);
          count = res.data.total;
        } else if (res.data && Array.isArray(res.data)) {
          setOtherMasterList(res.data);
          settotalcount(res.data.length);
          count = res.data.length;
        }
        if (showToast) {
          toast.success(`Found ${count} results`);
        }
        setshow(false);
      })
      .catch(err => {
        console.log(err);
        if (showToast) {
          toast.error("Failed to apply filters");
        }
        setshow(false);
      });
  };

  const fetchMaterialMasters = async () => {
    if (
      !companyProfile?.domain_data?.company_id ||
      !userDetails
    ) {
      return;
    }

    const id = companyProfile.domain_data.company_id;
    setcompany_id(id);
    getMaterialData(buildDefaultPayload(0, 500), selectedOrg);
    setSkipactive(0);
  };


  // useeffect to set company details and fetch material masters
  useEffect(() => {
    fetchMaterialMasters();
  }, [companyProfile, userDetails, selectedOrg]);

  useEffect(() => {
    if (companySettingData && companySettingData.contact_information) {
      const result = isSuperUser(companySettingData.contact_information);
      if (result) {
        if (result.organizationList && result.organizationList.length > 0) {
          setOrgList(result.organizationList);
        }
      }
    }
    if (companySettingData && companySettingData.masters_setting) {
      if (
        companySettingData.masters_setting.masters_show_level &&
        companySettingData.masters_setting.masters_show_level ===
        "organization_level"
      ) {
        setIsOrgLevel(true);
      }
    }
  }, [companySettingData]);
  /**
   * Deletes a specific material from the list.
   * @param {Event} e - click event.
   * @param {Object} item - The item to be deleted.
   */
  const deleteHandler = (e, item) => {
    setshow(true);
    if (window.confirm("Are you sure you want to delete this material?")) {
      var temp = otherMasterList;
      var list = [];
      if (temp && temp.length > 0) {
        temp.map((data) => {
          if (data !== item) {
            list.push(data);
          }
        });
      }
      DeleteMastersApi(company_id, "material", [item], selectedOrg, TrackMixPanel)
        .then((res) => {
          setshow(false);
          sendMailToMasters(
            "Material Master",
            emailTemplate,
            superAdmins,
            {
              action: "Material Deleted",
              lane: item,
            },
            setshow,
            userDetails?.user_name || userDetails?.email?.split("@")[0]
          );
          setOtherMasterList(list);
          var activity = [
            {
              material_code: item.material_code,
              material_description: item.material_description,
            },
          ];
          MastersChangeLog(
            "Line Item Deleted",
            "material_master",
            userDetails.email,
            userDetails.user_id,
            company_id,
            activity
          );
          TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'masters -other masters -material master',
            Data: `material description: ${item?.material_description || 'none'}, material type: ${item?.material_type || 'none'}, material category: ${item?.material_category || 'none'}, material code: ${item?.material_code || 'none'}, length: ${item?.length || 'none'}, breadth: ${item?.breadth || 'none'}, volume: ${item?.volume || 'none'}, weight: ${item?.weight || 'none'}, height: ${item?.height || 'none'}`,
            Definition: 'user has clicked on material master delete button',
          });
        })
        .catch((error) => {
          console.log(error);
          setshow(false);
        });
    }
  };

  /**
   * Component for adding a new item to the material master list.
   * @param {Array} otherMasterList - list of existing material items.
   * @param {React.SetStateAction} setOtherMasterList - setter to update the list of materials.
   * @returns {JSX.Element}
   */

  const LENGTH_UNITS = [
    { label: "ft (feet)", value: "ft" },
    { label: "in (inches)", value: "in" },
    { label: "m (meters)", value: "m" },
    { label: "cm (centimeters)", value: "cm" },
    { label: "mm (millimeters)", value: "mm" },
  ];

  const UNIT_TO_FEET = {
    ft: 1,
    in: 1 / 12,
    m: 3.28084,
    cm: 0.0328084,
    mm: 0.00328084,
  };

  const convertToFeet = (value, unit) => {
    const numericValue = parseFloat(value);

    if (isNaN(numericValue)) return "";

    return Number((numericValue * UNIT_TO_FEET[unit]).toFixed(4));
  };

  const convertFromFeet = (valueInFeet, unit) => {
    const numFeet = parseFloat(valueInFeet);
    if (isNaN(numFeet)) return "";
    const factor = UNIT_TO_FEET[unit];
    if (!factor) return "";
    return (numFeet / factor).toFixed(4);
  };

  const convertVolumeFromCubicFeet = (valueInCubicFeet, unit) => {
    const numCubicFeet = parseFloat(valueInCubicFeet);
    if (isNaN(numCubicFeet)) return "";
    const factor = UNIT_TO_FEET[unit];
    if (!factor) return "";
    return (numCubicFeet / Math.pow(factor, 3)).toFixed(4);
  };

  const getLengthTooltip = (valueInFeet) => {
    if (valueInFeet === undefined || valueInFeet === null) return "";
    return LENGTH_UNITS.map(u => `${u.label}: ${convertFromFeet(valueInFeet, u.value)}`).join("\n");
  };

  const getVolumeTooltip = (valueInCubicFeet) => {
    if (valueInCubicFeet === undefined || valueInCubicFeet === null) return "";
    const VOLUME_UNITS = [
      { label: "ft³ (cubic feet)", value: "ft" },
      { label: "in³ (cubic inches)", value: "in" },
      { label: "m³ (cubic meters)", value: "m" },
      { label: "cm³ (cubic centimeters)", value: "cm" },
      { label: "mm³ (cubic millimeters)", value: "mm" },
    ];
    return VOLUME_UNITS.map(u => `${u.label}: ${convertVolumeFromCubicFeet(valueInCubicFeet, u.value)}`).join("\n");
  };


  const AddNewItem = ({ otherMasterList, setOtherMasterList }) => {
    const [materialDesription, setMaterialDesription] = useState("");
    const [materialType, setMaterialType] = useState("");
    const [materialCategory, setMaterialCategory] = useState("");
    const [materialCode, setMaterialCode] = useState();
    const [length, setlength] = useState();
    const [breadth, setBreadth] = useState();
    const [height, setHeight] = useState();
    const [volume, setVolume] = useState();
    const [weight, setWeight] = useState();
    const [lengthUnit, setLengthUnit] = useState("ft");

    // useEffect to set volume
    // useEffect(() => {
    //   if (height > 0 && length > 0 && breadth > 0) {
    //     const totalVolume = length * breadth * height;
    //     setVolume(Number(totalVolume.toFixed(4)));
    //   } else {
    //     setVolume("");
    //   }
    // }, [length, breadth, height]);

    useEffect(() => {
      const numericLength = parseFloat(length);
      const numericBreadth = parseFloat(breadth);
      const numericHeight = parseFloat(height);

      if (numericLength > 0 && numericBreadth > 0 && numericHeight > 0) {
        const totalVolume = numericLength * numericBreadth * numericHeight;
        setVolume(Number(totalVolume.toFixed(4)));
      } else {
        setVolume("");
      }
    }, [length, breadth, height]);

    /**
     * Adds a new material to the list.
     * @param {Event} e - click event for add.
     */
    const addMaterialMaster = (e) => {

      const lengthInFeet = convertToFeet(length, lengthUnit);
      const breadthInFeet = convertToFeet(breadth, lengthUnit);
      const heightInFeet = convertToFeet(height, lengthUnit);
      Activity([
        {
          screen: "Company Profile",
          module: "Material Master",
          user_activity: `Add Material Master Button Clicked`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      var lane = {
        material_description: materialDesription,
        material_type: materialType,
        material_code: materialCode,
        material_category: materialCategory,
        breadth: breadthInFeet,
        height: heightInFeet,
        length: lengthInFeet,
        volume: Number((lengthInFeet * breadthInFeet * heightInFeet).toFixed(4)),
        weight: parseFloat(weight),
      };
      // const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))/i;
      const sqlInjectionPatterns =
        /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

      if (sqlInjectionPatterns.test(materialDesription)) {
        toast.error("Please add valid material description");
      } else if (sqlInjectionPatterns.test(materialType)) {
        toast.error("Please add valid material type");
      } else if (sqlInjectionPatterns.test(materialCode)) {
        toast.error("Please add valid material code");
      } else if (sqlInjectionPatterns.test(materialCategory)) {
        toast.error("Please add valid material category");
      } else if (validateAllFields(lane)) {
        setshow(true);
        const lanes = [lane];
        saveMastersApi(company_id, "material", lanes, selectedOrg, TrackMixPanel)
          .then((res) => {
            if (res.data?.status === false) {
              toast.error(res.data?.message || "Error adding material");
              setshow(false);
              return;
            }
            else {
              setshow(false);
              toast.success("Details Added successfully");

              sendMailToMasters(
                "Material Master",
                emailTemplate,
                superAdmins,
                {
                  action: "New Material Added",
                  lane: lane
                },
                () => { },
                userDetails?.user_name || userDetails?.email?.split("@")[0]
              );

              var activity = {
                material_code: lane.material_code,
                material_description: lane.material_description,
              };
              MastersChangeLog(
                "Line Item Added",
                "material_master",
                userDetails.email,
                userDetails.user_id,
                company_id,
                activity,
                ""
              );
              TrackMixPanel({
                ModuleName: 'masters',
                ScreenName: 'masters -other masters -material master',
                Data: `material description: ${materialDesription || 'none'}, material type: ${materialType || 'none'}, material category: ${materialCategory || 'none'}, material code: ${materialCode || 'none'}, length: ${length || 'none'}, breadth: ${breadth || 'none'}, volume: ${volume || 'none'}, weight: ${weight || 'none'}, height: ${height || 'none'}`,
                Definition: 'user has clicked on add details material master button',
              });
              setOtherMasterList([...otherMasterList, lane]);
              setMaterialDesription('');
              setMaterialType('');
              setMaterialCategory('');
              setMaterialCode('');
              setlength('');
              setBreadth('');
              setHeight('');
              setVolume('');
              setWeight('');


              const closeBtn = document.getElementById("close_addMaterialMaster");
              if (closeBtn) closeBtn.click();
            }

          })
          .catch((err) => {
            console.log(err);
            setshow(false);
          });
      }
    };

    /**
     * Validates all fields of a new material.
     * @param {Object} lane - material item to be validated.
     * @returns {boolean} True if all fields are valid, else false.
     *
     * TODO : fix naming
     */
    const validateAllFields = (lane) => {
      if (
        lane.material_category.trim() === "" ||
        lane.material_code === undefined ||
        lane.material_description.trim() === "" ||
        lane.material_type.trim() === "" ||
        lane.breadth === undefined ||
        lane.height === undefined ||
        lane.length === undefined ||
        lane.volume === undefined ||
        lane.weight === undefined ||
        isNaN(lane.breadth) ||
        isNaN(lane.height) ||
        isNaN(lane.length) ||
        isNaN(lane.volume) ||
        isNaN(lane.weight) ||
        lane.volume === ""
      ) {
        toast.error("Please Fill All Fields");
        return false;
      } else if (
        lane.material_code <= 0 ||
        lane.breadth <= 0 ||
        lane.height <= 0 ||
        lane.length <= 0 ||
        lane.volume <= 0 ||
        lane.weight <= 0
      ) {
        toast.error("Field Cannot be 0 or Negative");
        return false;
      } else {
        return true;
      }
    };

    /**
     * Deletes multiple selected items from the list.
     * @param {Event} e - click event for delete button.
     */
    const deleteLanes = (e) => {
      if (deletion_list && deletion_list.length > 0) {
        if (window.confirm("are you sure to delete?")) {
          TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'masters -other masters - material master',
            Data: `deleted items: ${deletion_list.length === otherMasterList.length && otherMasterList.length > 3 ? 'all items' : deletion_list.map(deletedLane => deletedLane.material_code).join(', ')}`,
            Definition: 'user has clicked on material master bulk delete button',
          });
          setshow(true);
          var payload = {
            data: deletion_list,
          };
          let finalUrl = "";
          if (
            selectedOrg === "company" ||
            !selectedOrg ||
            selectedOrg === undefined
          ) {
            finalUrl = `${Urls.companyMaster}?company_id=${companyProfile.domain_data.company_id}&master_type=material&status=deleted`;
          } else {
            finalUrl = `${Urls.companyMaster}?company_id=${companyProfile.domain_data.company_id}&organization_id=${selectedOrg}&master_type=material&status=deleted`;
          }
          axios
            .post(finalUrl, payload)
            .then((res) => {
              toast.success("Lanes deleted successfully");
              sendMailToMasters(
                "Material Master",
                emailTemplate,
                superAdmins,
                {
                  action: `Multiple Item(s) Deleted`,
                  lane: '',
                },
                setshow,
                userDetails?.user_name || userDetails?.email?.split("@")[0]
              );
              const updatedList = otherMasterList.filter(
                (truck) =>
                  !deletion_list.some((deletedLane) => deletedLane === truck)
              );
              setOtherMasterList(updatedList);
              setshow(false);
              setDeletion_list([]);
            })
            .catch((err) => {
              console.log(err);
              setshow(false);
            });
        }
      } else {
        toast.error("Please Select atleast 1 item");
        return false;
      }
    };

    return (
      <div className="row col-md-12 px-3 pb-3">
        <div className="d-flex align-items-center flex-wrap w-100" style={{ gap: "10px" }}>
          <Modal
            buttonLabel={
              <>
                <i className="fa fa-plus pr-2" />
                Add Material Master
              </>
            }
            buttonClass="btn btn-primary"
            style={{ fontSize: "12px", backgroundColor: "#3f51b5", borderColor: "#3f51b5" }}
            disabled={canedit || !canUpdate}
            content={
              <div className="p-2">
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Material Description <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="text" className="form-control" style={{ height: "37px" }} onChange={(e) => setMaterialDesription(e.target.value)} value={materialDesription} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Material Type <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="text" className="form-control" style={{ height: "37px" }} onChange={(e) => setMaterialType(e.target.value)} value={materialType} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Material Category <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="text" className="form-control" style={{ height: "37px" }} onChange={(e) => setMaterialCategory(e.target.value)} value={materialCategory} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Material Code <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="text" className="form-control" style={{ height: "37px" }} onChange={(e) => setMaterialCode(e.target.value)} value={materialCode} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  {/* <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Length <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setlength(e.target.value)} value={length} disabled={canedit || !canUpdate} />
                    </label>
                  </div> */}
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Length ({lengthUnit}) <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setlength(e.target.value)} value={length} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Breadth ({lengthUnit}) <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setBreadth(e.target.value)} value={breadth} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Height ({lengthUnit}) <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setHeight(e.target.value)} value={height} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Volume ({lengthUnit}³) <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setVolume(e.target.value)} value={volume} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>Weight (kg) <span className="required-field"> *</span></span>
                    <label style={{ width: "100%", marginBottom: 0 }}>
                      <input type="number" className="form-control" style={{ height: "37px" }} onChange={(e) => setWeight(e.target.value)} value={weight} disabled={canedit || !canUpdate} />
                    </label>
                  </div>
                </div>
                <hr style={{ borderTop: "1px solid rgb(255 255 255 / 10%)", margin: "20px 8px" }} />
                <div
                  className="d-flex align-items-center justify-content-between mx-2 mb-4"
                  style={{
                    border: "1px solid rgb(255 255 255 / 10%)",
                    borderRadius: "8px",
                    backgroundColor: "rgb(255 255 255 / 3%)"
                  }}
                >
                  <div className="d-flex flex-column">
                    <span style={{ fontWeight: "600", fontSize: "14px" }}>
                      Dimension Unit <span className="required-field"> *</span>
                    </span>
                    <span style={{ fontSize: "12px", color: "#aaa", marginTop: "4px" }}>
                      Applies to Length, Breadth & Height
                    </span>
                  </div>
                  <div style={{ width: "35%", minWidth: "150px", maxWidth: "300px" }}>
                    <select
                      className="form-control"
                      style={{ height: "37px" }}
                      value={lengthUnit}
                      onChange={(e) => setLengthUnit(e.target.value)}
                      disabled={canedit || !canUpdate}
                    >
                      {LENGTH_UNITS.map((unit) => (
                        <option key={unit.value} value={unit.value}>
                          {unit.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row m-0 justify-content-center mt-4 mb-2">
                  <button className="btn btn-success px-4" disabled={canedit || !canUpdate} onClick={(e) => addMaterialMaster(e)}>Add Material Details</button>
                </div>
              </div>
            }
            title="Add Material Master"
            id="addMaterialMasterModal"
            closeButtonId="close_addMaterialMaster"
            screenName="Material Master"
            moduleName="Material Master"
            backdrop="static"
            size="xl"
          />
          <Modal
            buttonLabel={
              <>
                <i className="fa fa-upload mr-2" />
                Upload Files
              </>
            }
            buttonClass="btn btn-primary"
            style={{ fontSize: "12px" }}
            disabled={canedit || !canUpdate}
            content={
              <OtherUploadExcel
                selectedOrg={selectedOrg}
                superAdmins={superAdmins}
                emailTemplate={emailTemplate}
                company_id={company_id}
                otherMasterList={otherMasterList}
                setOtherMasterList={setOtherMasterList}
                fetchMaterialMaster={fetchMaterialMasters}
              />
            }
            title={`Material Master`}
            showLogo={true}
            id="closebutton"
            ScreenName="Company Profile"
            ModuleName="Material Master"
            activityName="Material Master - Upload excel"
          />
          <button
            id="submitLane"
            style={{}}
            disabled={deletion_list.length === 0 || canedit || !canUpdate}
            className={`btn btn-sm btn-danger ${superAdmin === false ? "btn-delete2" : "btn-delete1"}`}
            onClick={(e) => deleteLanes(e)}
          >
            <i className="fa fa-trash mr-2" />
            Delete
          </button>
          <DownloadMastersButton
            type={"material"}
            company_id={company_id}
            masterList={otherMasterList}
            totalCount={totalcount}
          />

          <button
            id="material-filter-btn"
            className={`btn ${isFilterActive ? 'btn-success' : 'btn-primary'} btn-sm px-3 text-nowrap`}
            onClick={() => setfiltershown(!filtersshown)}
            title={isFilterActive ? 'Filters are active' : 'Advanced Filters'}
          >
            <i className={`fa ${isFilterActive ? 'fa-check-circle' : 'fa-filter'} mr-2`} />
            {isFilterActive ? 'Filters Applied' : 'Filter'}
          </button>
          <div className="ml-auto">
            <Modal
              id="activity-log-modal"
              buttonLabel={
                <>
                  <i className="far fa-clock pr-2" style={{ fontSize: "15px" }}></i>
                  <span>Show Activity</span>
                </>
              }
              buttonClass={`btn btn-info btn-sm px-3 text-nowrap`}
              disabled={canedit || !canUpdate}
              content={<ShowHistory screen_name={'material_master'} />}
              screenName="Other Masters"
              moduleName="Masters"
              title='Activity Log'
            />
          </div>
        </div>
      </div>
    );
  };

  /**
   * Component for editing an existing material.
   * @param {Object} MaterialMaster - material to be edited.
   * @param {number} index - index of the item in the list.
   * @param {Object} userDetails - user details.
   * @returns {JSX.Element}
   */
  const EditMaterialMaster = ({ MaterialMaster, index, userDetails, superAdmins, emailTemplate }) => {
    const [length, setLength] = useState(MaterialMaster.length);
    const [breadth, setBreadth] = useState(MaterialMaster.breadth);
    const [height, setHeight] = useState(MaterialMaster.height);
    const [volume, setVolume] = useState();
    const [prevData, setPrevData] = useState({});

    // SET volume, breadth, height, length
    useEffect(() => {
      setVolume(MaterialMaster.volume);
      setHeight(MaterialMaster.height);
      setLength(MaterialMaster.length);
      setBreadth(MaterialMaster.breadth);
    }, []);

    // useeffect to set volume
    useEffect(() => {
      if (height > 0 && length > 0 && breadth > 0) {
        const totalVolume = length * breadth * height;
        setVolume(Number(totalVolume.toFixed(4)));
      } else {
        setVolume(0);
      }
    }, [height, length, breadth]);

    // useeffect to deep clone existing materials
    useEffect(() => {
      var temp = _.cloneDeep(MaterialMaster);
      setPrevData(temp);
    }, [MaterialMaster]);

    const handleEditSave = async (MaterialMaster) => {
      try {
        // -------------------------
        // Prepare Edited Object
        // -------------------------
        const editMaterialMaster = {
          breadth: Number(breadth),
          height: Number(height),
          length: Number(length),
          material_category: MaterialMaster.material_category?.trim(),
          material_code: MaterialMaster.material_code?.trim(),
          material_description: MaterialMaster.material_description?.trim(),
          material_type: MaterialMaster.material_type?.trim() || "NA",
          volume: Number(volume),
          weight: Number(MaterialMaster.weight),
        };

        // -------------------------
        // Basic Validation
        // -------------------------
        if (
          !editMaterialMaster.material_category ||
          !editMaterialMaster.material_description ||
          !editMaterialMaster.material_type ||
          isNaN(editMaterialMaster.breadth) || editMaterialMaster.breadth <= 0 ||
          isNaN(editMaterialMaster.height) || editMaterialMaster.height <= 0 ||
          isNaN(editMaterialMaster.length) || editMaterialMaster.length <= 0 ||
          isNaN(editMaterialMaster.volume) || editMaterialMaster.volume <= 0 ||
          isNaN(editMaterialMaster.weight)
        ) {
          toast.error("Please fill all fields correctly");
          return;
        }

        setshow(true);

        // -------------------------
        // Track Changes
        // -------------------------
        const changedValues = findChangedValues(
          prevData,
          editMaterialMaster,
          "changed_value"
        );

        const previous_data = findChangedValues(
          prevData,
          changedValues,
          "original_value"
        );

        const activity = {
          material_code: prevData.material_code,
          existing_data: previous_data,
          updated_data: changedValues,
        };

        MastersChangeLog(
          "Line Item Updated",
          "material_master",
          userDetails.email,
          userDetails.user_id,
          company_id,
          activity,
          ""
        );

        TrackMixPanel({
          ModuleName: "masters",
          ScreenName: "masters -other masters -material master",
          data: `
        material description: ${editMaterialMaster.material_description || "none"},
        material type: ${editMaterialMaster.material_type || "none"},
        material category: ${editMaterialMaster.material_category || "none"},
        material code: ${editMaterialMaster.material_code || "none"},
        length: ${editMaterialMaster.length || "none"},
        breadth: ${editMaterialMaster.breadth || "none"},
        volume: ${editMaterialMaster.volume || "none"},
        weight: ${editMaterialMaster.weight || "none"},
        height: ${editMaterialMaster.height || "none"}
      `,
          Definition: "user has clicked on material master save button",
        });

        // -------------------------
        // API Call
        // -------------------------
        const baseUrl = `${Urls.companyMaster}?master_type=material&company_id=${company_id}&edit_filter=true`;

        const url =
          selectedOrg && selectedOrg !== "company"
            ? `${baseUrl}&organization_id=${selectedOrg}`
            : baseUrl;

        await axios.post(url, { data: [editMaterialMaster] });

        // -------------------------
        // Refresh + Mail
        // -------------------------
        let updatedPayload = null;
        let isFilterStillActive = isFilterActive;

        if (isFilterActive && filterPayload) {
          const editedFields = [];
          if (prevData.material_description !== editMaterialMaster.material_description) {
            editedFields.push("material_description");
          }
          if (prevData.material_type !== editMaterialMaster.material_type) {
            editedFields.push("material_type");
          }
          if (prevData.material_category !== editMaterialMaster.material_category) {
            editedFields.push("material_category");
          }
          if (prevData.material_code !== editMaterialMaster.material_code) {
            editedFields.push("material_code");
          }
          if (Number(prevData.weight) !== Number(editMaterialMaster.weight)) {
            editedFields.push("weight");
          }
          if (Number(prevData.volume) !== Number(editMaterialMaster.volume)) {
            editedFields.push("volume");
          }

          const currentFilters = filterPayload.filters || [];
          const updatedFilters = currentFilters.filter(f => !editedFields.includes(f.key));

          const onlyOneFilterAppliedAndEdited = currentFilters.length === 1 && editedFields.includes(currentFilters[0].key);

          const currentSortKey = filterPayload.sort?.key;
          const isDefaultSort = currentSortKey === "material_code" || !currentSortKey;
          const hasSort = !isDefaultSort;

          const currentLimit = filterPayload.pagination?.limit;
          const hasPagination = currentLimit && currentLimit !== 500;

          const hasFilters = updatedFilters.length > 0;
          const hasSearch = filterPayload.search && filterPayload.search.trim() !== "";

          if (onlyOneFilterAppliedAndEdited || (!hasFilters && !hasSearch && !hasSort && !hasPagination)) {
            isFilterStillActive = false;
            updatedPayload = null;
          } else {
            updatedPayload = {
              ...filterPayload,
              filters: updatedFilters,
              pagination: { ...filterPayload.pagination, skip: 0 }
            };
          }
        }

        isSavedRef.current = true;

        if (!isFilterStillActive) {
          setIsFilterActive(false);
          setFilterPayload(null);
          setSkipactive(0);
          getMaterialData(buildDefaultPayload(0, 500), selectedOrg);
        } else {
          setFilterPayload(updatedPayload);
          setSkipactive(0);
          getMaterialData(updatedPayload, selectedOrg);
        }

        await sendMailToMasters(
          "Material Master",
          emailTemplate,
          superAdmins,
          {
            action: "Material Edited",
            lane: editMaterialMaster,
          },
          setshow,
          userDetails?.user_name || userDetails?.email?.split("@")[0]
        );

        toast.success("Details Edited Successfully");
        document.getElementById("close_contactus")?.click();

      } catch (err) {
        console.log(err);
        toast.error("Something went wrong");
      } finally {
        setshow(false);
      }
    };

    return (
      <>
        <div className={`row m-0`}>
          <div className={"col-md-4"}>
            <span style={{ fontWeight: "600" }}>Material Description</span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                onChange={(e) => {
                  MaterialMaster.material_description = e.target.value;
                }}
                defaultValue={MaterialMaster.material_description}
              />
            </label>
          </div>
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Material Type</span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                onChange={(e) => {
                  MaterialMaster.material_type = e.target.value;
                }}
                defaultValue={MaterialMaster.material_type}
              />
            </label>
          </div>
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Material Category</span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                onChange={(e) => {
                  MaterialMaster.material_category = e.target.value;
                }}
                defaultValue={MaterialMaster.material_category}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Material Code<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={MaterialMaster.material_code}
              />
            </label>
          </div>
        </div>
        <div className={`row m-0`}>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Length<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  setLength(Number(e.target.value));
                }}
                defaultValue={length}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Breadth<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  setBreadth(Number(e.target.value));
                }}
                defaultValue={breadth}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Height<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  setHeight(Number(e.target.value));
                }}
                defaultValue={height}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Volume<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  setVolume(Number(e.target.value));
                }}
                defaultValue={volume}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Weight<span className="required-field"> *</span></span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  MaterialMaster.weight = Number(e.target.value);
                }}
                defaultValue={MaterialMaster.weight}
              />
            </label>
          </div>
        </div>
        <div className={`text-center`}>
          <button
            className={`${classes["save-btn"]} btn btn-success`}
            onClick={() => handleEditSave(MaterialMaster)}
          >
            Save
          </button>
        </div>
      </>
    );
  };

  // const handleSave = (otherMasterList) => {
  //     setshow(true)
  //     var other_master = otherMasterList.map((list) => {
  //         return {
  //             "breadth": list.breadth,
  //             "height": list.breadth,
  //             "length": list.length,
  //             "material_category": list.material_category,
  //             "material_code": list.material_code,
  //             "material_description":list.material_description,
  //             "material_type": list.material_type ? list.material_type : 'NA',
  //             "volume": list.volume,
  //             "weight": list.weight,
  //         }
  //     })
  //     saveMastersApi(company_id, 'material', other_master)
  //     .then(res => {
  //         setshow(false)
  //         toast.success("Data submitted successfully")
  //     })
  //     .catch(err => {
  //         console.log(err)
  //         setshow(false)
  //     })
  // }

  /**
   * Closes the event and refreshes the material master.
   */
  const closeEvent = async () => {
    if (isSavedRef.current) {
      isSavedRef.current = false;
      return;
    }
    setshow(true);
    if (isFilterActive && filterPayload) {
      getMaterialData(filterPayload, selectedOrg);
    } else {
      if (companyProfile) {
        if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
          var id = companyProfile.domain_data.company_id;
          setcompany_id(id);
          await getCompanyMaster(id, "material", selectedOrg)
            .then((res) => {
              if (res.data && res?.data?.master_details) {
                setOtherMasterList(res?.data?.master_details);
              }
              setshow(false);
            })
            .catch((err) => {
              console.log(err);
              setshow(false);
            });
        }
      }
    }
  };

  /**
   * Selects or deselects all items in the list for deletion.
   * @param {Event} e - change event.
   */
  const selectAllHandler = (e) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      if (otherMasterList && otherMasterList.length > 0) {
        otherMasterList.map((item) => {
          if (!deletion_list.includes(item)) {
            list.push(item);
          }
        });
        setDeletion_list(list);
        TrackMixPanel({
          ModuleName: 'masters',
          ScreenName: 'masters -other masters -material master',
          Data: `selected all ${otherMasterList.length} items`,
          Definition: 'user selected all items for deletion in material master',
        });
      }
    } else {
      setDeletion_list([]);
    }
  };

  /**
   * Handles the checkbox selection for materials in the list.
   * @param {Event} e - change event.
   * @param {Object} item - material associated with the checkbox.
   */
  const checkboxeshandler = (e, item) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      list.push(item);
      setDeletion_list(list);
      TrackMixPanel({
        ModuleName: 'masters',
        screenName: 'masters -other masters -material master ',
        Data: `material code: ${item.material_code}`,
        Definition: 'user selected item for deletion in material master',
      });
    } else {
      var temp = deletion_list.filter((value) => value !== item);
      setDeletion_list(temp);
      TrackMixPanel({
        ModuleName: 'masters',
        ScreenName: ' ',
        Data: `material code: ${item.material_code}`,
        Definition: 'user deselected item in material master',
      });
    }
  };


  const handleFilterApply = (payload, showToast = true) => {
    setIsFilterLoading(true);
    setIsFilterActive(true);
    setFilterPayload(payload);

    if (payload?.pagination?.skip === 0) {
      setSkipactive(0);
    }

    getMaterialData(payload, selectedOrg, showToast);
    setIsFilterLoading(false);
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setSkipactive(0);
    getMaterialData(buildDefaultPayload(0, 500), selectedOrg);
    toast.info('Filters reset');
  };


  const ActiveFilterPills = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters = filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch = filterPayload.search && filterPayload.search.trim() !== '';

    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === 'material_code' || !currentSortKey;
    const currentSortLabel = DEFAULT_SORT_OPTIONS.find(o => o.value === currentSortKey)?.label || currentSortKey;
    const hasSort = !isDefaultSort;

    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 500;

    if (!hasFilters && !hasSearch && !hasSort && !hasPagination) return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(f => f.key !== filterKey);
      if (updatedFilters.length === 0 && (!filterPayload.search || filterPayload.search.trim() === '') && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        const updated = { ...filterPayload, filters: updatedFilters, pagination: { ...filterPayload.pagination, skip: 0 } };
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const clearSearch = () => {
      const updated = { ...filterPayload, search: '', pagination: { ...filterPayload.pagination, skip: 0 } };
      if (!hasFilters && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetSort = () => {
      const updated = { ...filterPayload, sort: { key: 'material_code', order: 'asc' }, pagination: { ...filterPayload.pagination, skip: 0 } };
      if (!hasFilters && !hasSearch && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetPagination = () => {
      const updated = { ...filterPayload, pagination: { ...filterPayload.pagination, limit: 500, skip: 0 } };
      if (!hasFilters && !hasSearch && !hasSort) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const formatValue = (value) => Array.isArray(value) ? value.join(', ') : value;

    return (
      <div className={classes["active-filters-area"]}>
        <div className={classes["filter-header"]}>
          <i className="fa fa-filter mr-2 text-primary" />
          <span className={classes["filter-text"]}>
            Active Filters
          </span>
        </div>

        <div className={classes["filter-content"]}>
          {hasSearch && (
            <div className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}>
              <span className={classes["filter-pill-text"]}>
                <i className={`fa fa-search mr-1 text-info ${classes["filter-pill-icon"]}`} />
                <strong className="mr-1">Search:</strong> {filterPayload.search}
              </span>
              <i className="fa fa-times ml-2 text-danger" onClick={clearSearch} />
            </div>
          )}

          {filterPayload.filters?.map((f, i) => (
            <div key={`${f.key}_${i}`} className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}>
              <span className={classes["filter-pill-text"]}>
                <i className={`fa fa-check-circle mr-1 text-success ${classes["filter-pill-icon"]}`} />
                <strong className="mr-1">{f.label || f.key}:</strong> {formatValue(f.values)}
              </span>
              <i className="fa fa-times ml-2 text-danger" onClick={() => removeFilter(f.key)} />
            </div>
          ))}

          {hasSort && (
            <div className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}>
              <span className={classes["filter-pill-text"]}>
                <i className={`fa fa-sort mr-1 text-warning ${classes["filter-pill-icon"]}`} />
                <strong className="mr-1">Sort:</strong> {currentSortLabel}
              </span>
              <i className="fa fa-times ml-2 text-danger" onClick={resetSort} />
            </div>
          )}

          {hasPagination && (
            <div className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}>
              <span className={classes["filter-pill-text"]}>
                <i className={`fa fa-list-ol mr-1 ${classes["filter-pill-icon"]}`} />
                <strong className="mr-1">Limit:</strong> {currentLimit}
              </span>
              <i className="fa fa-times ml-2 text-danger" onClick={resetPagination} />
            </div>
          )}
        </div>

        <button className={classes["btn-clear-all"]} onClick={handleFilterReset}>
          Clear All
        </button>
      </div>
    );
  };
  /**
   * Handles page changes in the pagination and fetches new pages.
   * @param {number} e - new page number.
   */
  const getOnChange = (e) => {
    setSkipactive(e);
    if (isFilterActive && filterPayload) {
      const currentLimit = filterPayload?.pagination?.limit || 500;
      const dynamicSkip = (e - 1) * currentLimit;
      const updated = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, skip: dynamicSkip, limit: currentLimit }
      };
      setFilterPayload(updated);
      getMaterialData(updated, selectedOrg);
    } else {
      const calculatedSkip = (e - 1) * 500;
      getMaterialData(buildDefaultPayload(calculatedSkip, 500), selectedOrg);
    }
  };

  return (
    <div>
      {filtersshown && (
        <div className="mt-4 mb-4">
          <MultiSelectFilterUI
            module="MaterialMaster"
            action="filterable_fields"
            filterBaseUrl={Urls.planning_master_filters}
            uniqueValuesMasterType="material"
            defaultFields={[
              { key: 'material_description', label: 'Material Description', type: 'text' },
              { key: 'material_type', label: 'Material Type', type: 'text' },
              { key: 'material_category', label: 'Material Category', type: 'text' },
              { key: 'material_code', label: 'Material Code', type: 'text' },
              { key: 'weight', label: 'Weight (kg)', type: 'number' },
              { key: 'volume', label: 'Volume (ft³)', type: 'number' },
            ]}
            defaultSortOptions={DEFAULT_SORT_OPTIONS}
            onFilterApply={handleFilterApply}
            onReset={handleFilterReset}
            initialPayload={filterPayload}
            isLoading={isFilterLoading || show}
            onClose={() => setfiltershown(false)}
            showSearch={false}
          />
        </div>
      )}

      <div className={`${classes["other-container"]}`}>
        <MasterDropdown
          activeTab="material-master"
          selectedOrg={selectedOrg}
          setSelectedOrg={setSelectedOrg}
          orgList={orgList}
          isOrgLevel={isOrgLevel}
          setSkipactive={setSkipactive}
          canedit={canedit}
          canUpdate={canUpdate}
          checkActionPermission={checkActionPermission}
        />
        <AddNewItem
          otherMasterList={otherMasterList}
          setOtherMasterList={setOtherMasterList}
        />
        <div className="row col-md-12 px-0 mx-0">
          <div className="col-12 px-0">
            <ActiveFilterPills />
          </div>
        </div>
        <div>
          <div className={`${classes["table-alignment"]} `}>
            <div className={`position-absolute w-100 ${show ? "h-50" : ""}`}>
              <Loader show={show} />
            </div>
            <table
              className={`${classes["table-width"]} table-borderless`}
              id="freight_master_table"
            >
              <thead className={`${classes["table-head"]}`}>
                <tr style={{ fontSize: "14px" }}>
                  <th className={`${classes["sticky-th1"]} pl-2`} style={{ width: '2%' }}>
                    <input
                      type="checkbox"
                      checked={
                        otherMasterList &&
                        otherMasterList.length > 0 &&
                        deletion_list.length === otherMasterList.length
                      }
                      onChange={selectAllHandler}
                      style={{ width: "15px", height: "15px" }}
                    />
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '3%' }}
                  >
                    Sr No.
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]} ${classes["material-des"]}`}
                    style={{ textAlign: "center", width: '20%' }}
                  >
                    Material Description
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '10%' }}
                  >
                    Material Type
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '10%' }}
                  >
                    Material Category
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '10%' }}
                  >
                    Material Code
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '8%' }}
                  >
                    Length(ft)
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '8%' }}
                  >
                    Breadth(ft)
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '8%' }}
                  >
                    Height(ft)
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '8%' }}
                  >
                    Volume(ft³)
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '8%' }}
                  >
                    Weight(kg)
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: '5%' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {otherMasterList && otherMasterList.length > 0
                  ? otherMasterList.map((data, index) => {
                    return (
                      <tr key={`${data.material_description}_${index}`}>
                        <td className={` pl-2 ${classes["borderforTd"]}`} style={{ width: '2%' }}>
                          <input
                            type="checkbox"
                            style={{ width: "15px", height: "15px" }}
                            onChange={(e) => checkboxeshandler(e, data)}
                            checked={deletion_list.includes(data)}
                          />
                        </td>
                        <td
                          style={{ textAlign: "center", width: '3%' }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {((skipactive === 0 ? 1 : skipactive) - 1) * (filterPayload?.pagination?.limit || 500) + index + 1}.
                        </td>
                        <td
                          style={{ textAlign: "center", width: "20%" }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {data?.material_description}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '10%' }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {data?.material_type}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '10%' }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {data?.material_category}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '10%' }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {data?.material_code}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '8%', cursor: 'pointer' }}
                          className={`${classes["borderforTd"]}`}
                          title={getLengthTooltip(data?.length)}
                        >
                          {data?.length?.toFixed(4)}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '8%', cursor: 'pointer' }}
                          className={`${classes["borderforTd"]}`}
                          title={getLengthTooltip(data?.breadth)}
                        >
                          {data?.breadth?.toFixed(4)}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '8%', cursor: 'pointer' }}
                          className={`${classes["borderforTd"]}`}
                          title={getLengthTooltip(data?.height)}
                        >
                          {data?.height?.toFixed(4)}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '8%', cursor: 'pointer' }}
                          className={`${classes["borderforTd"]}`}
                          title={getVolumeTooltip(data?.volume)}
                        >
                          {data?.volume?.toFixed(4)}
                        </td>
                        <td
                          style={{ textAlign: "center", width: '8%' }}
                          className={`${classes["borderforTd"]}`}
                        >
                          {data?.weight?.toFixed(4)}
                        </td>
                        <td
                          className={`${classes["borderforTd"]}`}
                          style={{ textAlign: "center", width: '5%' }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Modal
                              buttonLabel={<i className="fa fa-pencil" />}
                              buttonClass={`btn btn-link text-dark`}
                              style={{}}
                              disabled={canedit || !canUpdate}
                              content={
                                <EditMaterialMaster
                                  superAdmins={superAdmins}
                                  emailTemplate={emailTemplate}
                                  MaterialMaster={data}
                                  index={index}
                                  userDetails={userDetails}
                                />
                              }
                              title={`Edit Material Master`}
                              id="materialmaster"
                              screenName="Edit Material Master"
                              moduleName="Edit Material Master"
                              onClose={closeEvent}
                            />
                            <button
                              className="btn btn-link text-dark"
                              onClick={(e) => deleteHandler(e, data)}
                              style={{}}
                              disabled={canedit || !canUpdate}
                            >
                              <i
                                className={`fa fa-trash`}
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                  : null}
              </tbody>
            </table>
          </div>
          <center>
            <Pagination
              activePage={skipactive === 0 ? 1 : skipactive}
              itemsCountPerPage={filterPayload?.pagination?.limit || 500}
              totalItemsCount={totalcount}
              onChange={(e) => getOnChange(e)}
              itemClass="page-item"
              linkClass="page-link"
            />
          </center>
        </div>
      </div>
    </div>
  );
};

export default OtherMaster;
